module.exports = __webpack_public_path__ + "static/media/thumb.d40b19a4.jpg";